/**
 * livechat-socket.ts
 *
 * Socket.io / VChat protocol layer for the standalone Live Chat widget.
 *
 * Live Chat is human-support only — every conversation opens a VChat room
 * directly (no AI bot, no escalation trigger). This module is a pure
 * types + constants file (no React, no side-effects); the socket lifecycle
 * (ensureSocket, requestRoom, joinRoom) lives in use-livechat.ts because it
 * needs React refs and state-update callbacks.
 *
 * Kept self-contained (does not import the Ask AI modules) so Live Chat is a
 * fully independent feature.
 */

export const SOCKET_TIMEOUT_MS = 10_000;

/**
 * How many recent messages to include in the chatHistory payload when
 * requesting or re-joining a human-support room.
 */
export const HISTORY_LIMIT = 10;

/**
 * Incoming room-history message from the VChat server (join-room response).
 * Shape matches the `messages[]` array returned by the `join-room` ack.
 */
export interface ServerMessage {
  id: string;
  content: string;
  sender: 'agent' | 'employee' | 'user' | 'system';
  createdAt: string;
  user?: { name?: string };
  /** Attachment fields (present for image/file messages). */
  type?: string;
  fileUrl?: string;
  fileName?: string;
  fileSize?: number;
}
